import { Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-javascript';

import Service from "../../../../util/Service";
const BmcBusinessTask = React.forwardRef((props, ref) => {
    const { item, processo } = props;

    const [code, setCode] = React.useState('');
    const [timeout, setTimeout] = React.useState('30');
    const [sucesso, setSucesso] = React.useState("retorno == true")
    const [falha, setFalha] = React.useState("retorno == false")
    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            salva();
          }
    }))

    React.useEffect(()=>{
        const tk = processo.lstTask.find( t => t.idTask === item.id);
        console.log(1);
        if( tk ){
            setCode( tk.dado.code );
            setTimeout( tk.dado.timeout)
            setSucesso( tk.dado.sucesso)
            setFalha( tk.dado.falha)
        }else{
            buscaCodigo('BmcProcess.txt');
        }
    },[]);
    function buscaCodigo(exemplo){
        if( !exemplo) return;
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/"+exemplo) 
        .then(r => {
            setCode(r)
        });
    };

    function salva(){
        console.log('>>>salva from Filho<<<');

        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,   
            tipo: 'BMC',
            dado: {
                code: code,
                timeout: timeout,
                sucesso: sucesso,
                falha: falha
            }
        }

        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log( resp );    
        }).catch(error => {
            console.error(error)
        })
        console.log( dado );
    }
    return (
        <Grid container spacing={2}>
            <Grid size={6}>
            <Paper>
                <Typography>Implemente a transformação</Typography>
                <Editor
                    value={code}
                    onValueChange={t => setCode(t)}
                    highlight={code => {
                        // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                        return highlight(code, languages.js)
                    }}
                    padding={10}
                    style={{
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 12,
                        minHeight: '400px'
                    }}
                />
            </Paper>
            </Grid>
            <Grid size={6}>
                <Stack spacing={2}>
                    <TextField id="timeOut" label="Tempo de espera timeout" variant="outlined" value={timeout} onChange={(e) => setTimeout(e.target.value)} />
                    <TextField id="outlined-basic" label="Sucesso" variant="outlined" value={sucesso} onChange={(e) => setSucesso(e.target.value)}/>
                    <TextField id="outlined-basic" label="Falha" variant="outlined" value={falha} onChange={(e) => setFalha(e.target.value)} />

                </Stack>
            </Grid>
            
        </Grid>
    )

})

export default BmcBusinessTask;